import { ActionIcon, Menu } from '@mantine/core';
import {
  IconBallpen,
  IconDots,
  IconPlayerPlay,
  IconPlayerSkipForward,
  IconPlayerStop,
  IconRefreshAlert,
  IconTrash,
  IconUserCheck,
} from '@tabler/icons';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { WorkflowS } from '../../../Service/WorkflowS';
import { WorkflowDTO, WorkflowOperation } from '../../../Types/LogT';
import { handleWorkflowForceContinue } from './forceContinue';

interface Props {
  workflow: WorkflowDTO;
  onDelete: () => void;
  runOperation: (operation: WorkflowOperation) => void;
}

const WorkflowActions: FC<Props> = ({ workflow, onDelete, runOperation }) => {
  const { templateId, possibleOperations, executionStatus } = workflow;
  const navigate = useNavigate();

  const removeWorkflow = async () => {
    const deleted = await WorkflowS.deleteWorkflow(workflow);
    if (deleted) {
      onDelete();
    }
  };

  return (
    <ActionIcon size="lg" mt="sm">
      <Menu withinPortal radius="md" shadow="md" transition="scale-y" position="bottom-end">
        <Menu.Target>
          <ActionIcon id="open-workflow-menu">
            <IconDots />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          {possibleOperations.includes('START') && (
            <Menu.Item
              id="start-workflow"
              icon={<IconPlayerPlay color="#4EBF46" size={16} />}
              onClick={() => runOperation('START')}
            >
              Workflow starten
            </Menu.Item>
          )}
          {possibleOperations.includes('FORCE_CONTINUE') && (
            <Menu.Item
              icon={<IconPlayerPlay color="#FEC170" size={16} />}
              onClick={() => handleWorkflowForceContinue(workflow, runOperation)}
            >
              {executionStatus === 'WAITING' ? 'Manuell akzeptieren' : 'Fortsetzen'}
            </Menu.Item>
          )}
          {possibleOperations.includes('RETRY') && (
            <Menu.Item icon={<IconRefreshAlert size={16} color="red" />} onClick={() => runOperation('RETRY')}>
              Wiederholen
            </Menu.Item>
          )}
          {possibleOperations.includes('APPROVE') && (
            <Menu.Item icon={<IconUserCheck size={16} color="orange" />} onClick={() => runOperation('APPROVE')}>
              Jetzt genehmigen
            </Menu.Item>
          )}
          {possibleOperations.includes('CONTINUE') && (
            <Menu.Item
              icon={<IconPlayerSkipForward size={16} color="orange" />}
              onClick={() => runOperation('CONTINUE')}
            >
              Weitermachen
            </Menu.Item>
          )}
          {possibleOperations.includes('PAUSE') && (
            <Menu.Item icon={<IconPlayerStop size={16} color="red" />} onClick={() => runOperation('PAUSE')}>
              Stoppen
            </Menu.Item>
          )}
          <Menu.Divider />
          {templateId && (
            <Menu.Item
              icon={<IconBallpen size={16} />}
              onClick={() => navigate(`/settings/workflow/templates/${templateId}`)}
            >
              Vorlage bearbeiten
            </Menu.Item>
          )}
          <Menu.Item color="red" icon={<IconTrash size={16} />} onClick={removeWorkflow}>
            Löschen
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </ActionIcon>
  );
};

export default WorkflowActions;
